
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyNumericHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledNumberCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { NumericFilter } from "../../../../components/Form/FormStyles";

export function CommunityPlantedDBHHeader() {
	return (
		<StickyNumericHeader
			style={{
				...offsetOneRow,
				width: '125px',
				minWidth: '125px',
				maxWidth: '125px'
			}}>
			Community planted DBH
		</StickyNumericHeader>
	)
}

export function CommunityPlantedDBHFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyNumericHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CommunityDBHTreesPlantedValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							CommunityDBHTreesPlantedValidated: e.value
						})
					}
				/>
				<NumericFilter
					value={filter?.CommunityDBHTreesPlanted ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							CommunityDBHTreesPlanted: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyNumericHeader>
	)
}

export function CommunityPlantedDBHContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledNumberCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CommunityDBHTreesPlantedValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>{ppn.PlantingProject.CommunityDBHTreesPlanted}</span>
			</CellWithValidator>
		</StateStyledNumberCell>
	)
}